<template>
  <div class="headFixed">
    <HeadNav title="设备状态"></HeadNav>
    <div class="list list_normal list_no_arrow list_info">
      <div class="item">
        <div class="clear">
          <p>用户侧回水温度 <span
              class="right">{{ this.info.userRetTemp ? this.info.userRetTemp + '℃' : '0℃' }}</span></p>
        </div>
      </div>
      <div class="item">
        <div class="clear">
          <p>用户侧出水温度 <span
              class="right">{{ this.info.userSupTemp ? this.info.userSupTemp + '℃' : '0℃' }}</span></p>
        </div>
      </div>
      <div class="item">
        <div class="clear">
          <p>地源侧回水温度 <span
              class="right">{{ this.info.groundRetTemp ? this.info.groundRetTemp + '℃' : '0℃' }}</span></p>
        </div>
      </div>
      <div class="item">
        <div class="clear">
          <p>地源侧出水温度 <span
              class="right">{{ this.info.groundSupTemp ? this.info.groundSupTemp + '℃' : '0℃' }}</span></p>
        </div>
      </div>
      <div class="item">
        <div class="clear">
          <p>环境温度 <span
              class="right">{{ this.info.envTemp ? this.info.envTemp + '℃' : '0℃' }}</span></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeadNav from '../../headNav/headNav'

export default {
  name: 'info',
  data() {
    return {
      info: {
        userRetTemp: null,// 送水回水温度
        userSupTemp: null,// 送水出水温度
        groundRetTemp: null,// 冷凝回水温度
        groundSupTemp: null,//冷凝出水温度
      },
      // path: 'ws://192.168.2.187:8080/ws/',
      // socket: "",
    }
  },
  components: {
    'HeadNav': HeadNav
  },
  mounted() {
    this.readWaterTemerature();
    this.firstRequest = true;
  },
  methods: {
    readWaterTemerature() {
      let str = 'id=' + this.getId();
      this.Api.eqDetail(this.getId(), (msg) => {
        if (msg.code === 200) {
          this.info = msg.data.airCondition;

          if (this.firstRequest) {
            //初始化websocket
            if (typeof (WebSocket) === "undefined") {
              alert("您的浏览器不支持socket")
            } else {
              // 实例化socket
              this.socket = this.$store.state.websocket;
              // 监听socket连接
              this.socket.onopen = this.socketopen
              // 监听socket错误信息
              this.socket.onerror = this.socketerror
              // 监听socket消息
              this.socket.onmessage = this.getMessage
              // 关闭socket消息
              this.socket.onclose = this.socketclose
            }
          }

          this.firstRequest = false;
        }
      })
    },
    getId() {
      return this.$route.params.id;
    },
    socketopen: function () {
      console.log("socket连接成功")
    },
    socketerror: function () {
      console.log("连接错误")
    },
    getMessage: function (msg) {
      let data = JSON.parse(msg.data);

      //设备上设定的制冷的温度
      if (data.userRetTemp) {
        this.info.userRetTemp = data.userRetTemp;
      }
      //送水
      if (data.userSupTemp) {
        this.info.userSupTemp = data.userSupTemp;
      }
      //水冷：冷凝回水温度 用于主机设备
      if (data.groundRetTemp) {
        this.info.groundRetTemp = data.groundRetTemp;
      }
      //水冷：冷凝出水温度 用于主机设备
      if (data.groundSupTemp) {
        this.info.groundSupTemp = data.groundSupTemp;
      }
      if (data.envTemp) {
        this.info.envTemp = data.envTemp;
      }

    },
    socketclose: function () {
      console.log("socket已经关闭")
      this.socket.close()
    }
  }
}
</script>
<style scoped>
@import url('../../../assets/list.css');
</style>





// WEBPACK FOOTER //
// src/components/equipment/status/status.vue